<template>
  <VButton
    :class="animated && 'relative overflow-hidden justify-center flex items-center'"
    :disabled="disabled"
  >
    <template v-if="disabled && !onlineManager.isOnline()">
      <div :class="twMerge('duration-500 transition-transform translate-y-14')">
        <slot />
      </div>
      <div
        :class="twMerge('absolute transition-transform duration-500 translate-y-0')"
      >
        <VIconSpinner class="animate-spin mx-1 h-4 w-4 spinner" />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </VButton>
</template>

<script setup>
import { twMerge } from 'tailwind-merge';
import { onlineManager } from '@tanstack/vue-query';
import { onBeforeUnmount, ref } from 'vue';
import VIconSpinner from '../../icons/VIconSpinner.vue';
import VButton from './VButton.vue';

defineProps({
  animated: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const online = ref(onlineManager.isOnline());

const unsubscribe = onlineManager.subscribe((isOnline) => online.value = isOnline);

onBeforeUnmount(() => unsubscribe());
</script>
